<template>
  <AsteonlineCard>
    <CardHead>
      {{ $t("auction.lot_list") }}
    </CardHead>
    <CardBody>
      <LotTabs :visible-tab="visibleTab" :auction="auction" @change-tab="visibleTab = $event" />

      <div v-if="visibleTab == 'standard'">
        <table class="w-full">
          <LotHeading :auction="auction" />
          <LotCompactItem v-for="lot in sortedLots" :key="'auction-full-item-lotcompactitem-' + lot.uuid" :lot="lot"
            :product-map="productMap" :show-if-bookmarked="onlyBookmark"
            :my-lot="authStore.canBid && auction.me ? auction.me.lots[lot.uuid] : null" :auction="auction"
            :is-outbid="lot.uuid == outbidLotUuid" @update-auction="$emit('update-auction', $event)" />
        </table>
      </div>

      <div v-if="visibleTab == 'redistribute'">
        <div v-if="!auction.lotRedistributes || auction.lotRedistributes.length == 0" class="p-6 text-center text-lg">
          {{ $t("auction.no_preemptions_available") }}
        </div>
        <table v-else class="w-full">
          <LotHeadingRedistribute :auction="auction" />
          <LotCompactItemRedistribute v-for="lot in auction.lotRedistributes"
            :key="'auction-full-item-lotcompactitem-redistribute-' + lot.uuid" :lot="lot" :product-map="productMap"
            :show-if-bookmarked="onlyBookmark" :my-lot="authStore.canBid && auction.me ? auction.me.lotRedistributes[lot.uuid] : null"
            :auction="auction" :is-outbid="lot.uuid == outbidLotUuid"
            @update-auction="$emit('update-auction', $event)" />
        </table>
      </div>
    </CardBody>
  </AsteonlineCard>
</template>

<script setup>
import { computed, ref } from 'vue';

import AsteonlineCard from '@/components/card/AsteonlineCard.vue';
import CardBody from '@/components/card/CardBody.vue';
import CardHead from '@/components/card/CardHead.vue';
import LotCompactItem from '@/components/lot/LotCompactItem.vue';
import LotCompactItemRedistribute from '@/components/lot/LotCompactItemRedistribute.vue';
import LotHeading from '@/components/lot/LotHeading.vue';
import LotHeadingRedistribute from '@/components/lot/LotHeadingRedistribute.vue';
import LotTabs from '@/components/lot/LotTabs.vue';
import { useAuthStore } from '@/stores/auth';

const emit = defineEmits(['update-auction'])

const props = defineProps({
  auction: {
    type: Object,
    required: true
  },
  productMap: {
    type: Object,
    required: true
  },
  onlyBookmark: {
    type: Boolean,
    required: true
  },
  outbidLotUuid: {
    type: String,
    required: false,
    default: null
  }
})

const authStore = useAuthStore();

const visibleTab = ref(
  props.auction.auctionStatus == 'REDISTRIBUTING_1' || props.auction.auctionStatus == 'REDISTRIBUTING_2' ?
    'redistribute' :
    'standard'
);

const sortedLots = computed(() => {
  return props.auction.lots.filter(lot => true).sort((a, b) => a.displayPosition - b.displayPosition);
});

</script>